import { Component, OnDestroy, OnInit } from '@angular/core';
import { HeaderService } from '@app/header/services/header.service';
import { TodoCount } from '@app/move/interfaces/todo-count';
import { DashboardMenuService } from '@app/real-estate-agent/components/dashboard-menu/dashboard-menu.service';
import { PosthogService } from '@app/tracking/posthog.service';
import { PosthogREALocations, PosthogREATodos } from '@app/tracking/enums/posthog.enum';
import { PostHogEventsEnum } from '@smooved/core';
import { UiRotate } from '@smooved/ui';
import { Observable } from 'rxjs';
import { DashboardMenu } from './dashboard-menu.constants';

@Component({
    selector: 'app-dashboard-menu',
    templateUrl: 'dashboard-menu.component.html',
    styleUrls: ['dashboard-menu.component.scss'],
})
export class DashboardMenuComponent implements OnInit, OnDestroy {
    public readonly dashboardMenu = DashboardMenu;
    public readonly rotate = UiRotate;
    public todosCount$: Observable<TodoCount>;

    constructor(
        public dashboardMenuService: DashboardMenuService,
        private readonly headerService: HeaderService,
        private readonly posthogService: PosthogService,
    ) {}

    public ngOnInit(): void {
        this.todosCount$ = this.dashboardMenuService.todosCount$;
        this.dashboardMenuService.reloadTodosCount();
    }

    public ngOnDestroy(): void {
        this.dashboardMenuService.resetMenu();
    }

    public setMenu(item: DashboardMenu): void {
        this.dashboardMenuService.setActiveMenu(item);
        this.headerService.dispatch();

        // Track click events for transferee and leaver menu items
        if (item === DashboardMenu.Transferees) {
            this.posthogService.sendEvent(PostHogEventsEnum.ClickToTransferee, {
                from: PosthogREALocations.TransactionListview,
            });
        } else if (item === DashboardMenu.Leavers) {
            this.posthogService.sendEvent(PostHogEventsEnum.ClickToLeaver, {
                from: PosthogREALocations.TransactionListview,
            });
        }

        // Track click events for todo buttons
        else if (
            item === DashboardMenu.AllTodos ||
            item === DashboardMenu.MetersNotCompletedTodos ||
            item === DashboardMenu.WaterNotComletedTodos
        ) {
            let todoType: PosthogREATodos;

            switch (item) {
                case DashboardMenu.AllTodos:
                    todoType = PosthogREATodos.All;
                    break;
                case DashboardMenu.MetersNotCompletedTodos:
                    todoType = PosthogREATodos.Energy;
                    break;
                case DashboardMenu.WaterNotComletedTodos:
                    todoType = PosthogREATodos.Water;
                    break;
            }

            this.posthogService.sendEvent(PostHogEventsEnum.ClickToDos, {
                from: todoType,
            });
        }
    }
}
